import styled from 'styled-components';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { PRODUCT_PREVIEW_HEIGHT } from './constants';

export const ProductsPreviewContainer = styled(Flex)
    .withConfig({
        displayName: 'ProductsPreviewContainer',
    })
    .attrs((props) => ({
        minHeight: PRODUCT_PREVIEW_HEIGHT,
        width: '100%',
        px: 1,
        py: 1,
        pl: 1,
        spacing: 0.5,
        flexShrink: 0,
        cursor: 'pointer',
        ...props,
        direction: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }))``;

export const ProductContent = styled(Box)
    .withConfig({
        displayName: 'ProductContent',
    })
    .attrs({})`
    align-content: center;
`;

export const Title = styled(Typography)
    .withConfig({
        displayName: 'Title',
    })
    .attrs((props) => ({
        ...props,
        variant: 'caption',
        lines: 1,
    }))`
    line-break: anywhere;
`;

export const MoreProductsBadge = styled(Typography)
    .withConfig({
        displayName: 'MoreProductsBadge',
    })
    .attrs({
        backgroundColor: 'var(--control-secondary-background)',
        p: 0.75,
        borderRadius: 4,
        weight: 'bold',
        variant: 'caption2',
    })``;
